import React from 'react';
import { Zap, ShieldCheck } from 'lucide-react';

export const QuickFillPersonas = ({ onSelect, activePersona, disabled }) => {
  const personas = [
    {
      id: 'demo',
      name: 'Demo Trader Sandbox',
      username: 'demo',
      password: 'Demo@Cyber2026!',
      role: 'PRO TIER',
      icon: Zap,
      accentBorder: 'hover:border-cyan-400/60 focus:border-cyan-400',
      activeBorder: 'border-cyan-400 bg-cyan-950/30 text-cyan-300 shadow-[0_0_15px_rgba(0,240,255,0.25)]',
      inactiveBorder: 'border-white/10 bg-white/[0.02] text-slate-300',
      badgeColor: 'bg-cyan-500/10 text-cyan-400 border border-cyan-500/30',
      iconColor: 'text-cyan-400'
    },
    {
      id: 'admin',
      name: 'Admin Console Preview',
      username: 'admin',
      password: 'Admin@Cyber2026!',
      role: 'SUPERUSER',
      icon: ShieldCheck,
      accentBorder: 'hover:border-fuchsia-400/60 focus:border-fuchsia-400',
      activeBorder: 'border-fuchsia-400 bg-fuchsia-950/30 text-fuchsia-300 shadow-[0_0_15px_rgba(217,70,239,0.25)]',
      inactiveBorder: 'border-white/10 bg-white/[0.02] text-slate-300',
      badgeColor: 'bg-fuchsia-500/10 text-fuchsia-400 border border-fuchsia-500/30',
      iconColor: 'text-fuchsia-400'
    }
  ];

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-[11px] font-mono text-slate-400 uppercase tracking-wider">
        <span className="flex items-center space-x-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-ping" />
          <span>Quick-Fill Personas</span>
        </span>
        <span className="text-[10px] text-slate-500">1-CLICK DEMO</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {personas.map((p) => {
          const Icon = p.icon;
          const isActive = activePersona === p.id;
          return (
            <button
              key={p.id}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(p.username, p.password, p.id)}
              className={`min-h-[48px] p-2.5 rounded-xl border text-left flex items-center justify-between transition-all duration-200 outline-none select-none ${
                isActive ? p.activeBorder : `${p.inactiveBorder} ${p.accentBorder}`
              } ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer active:scale-[0.98]'}`}
            >
              <div className="flex items-center space-x-2">
                <div className={`p-1.5 rounded-lg bg-black/40 ${p.iconColor}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <div>
                  <div className="text-xs font-semibold leading-tight">{p.name}</div>
                  <div className="text-[10px] font-mono text-slate-400">@{p.username}</div>
                </div>
              </div>
              <span className={`text-[9px] font-mono px-1.5 py-0.5 rounded ${p.badgeColor}`}>
                {p.role}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickFillPersonas;
